export default __webpack_public_path__ + "static/media/ic_correct_primary.dd06d5cb.svg";